<template>
  <section v-loading="loading" id="view-test-information-sendouts">
    <div class="case-creation__card">
      <div class="case-creation__heading">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-test-reports.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">Test Reports</h3>
        </div>
      </div>
      <div
        v-if="getSendOutInformation && getSendOutInformation?.test_reports?.length == 0"
        class="no-test-block"
      >
        No test reports found
      </div>
      <div v-if="getSendOutInformation && getSendOutInformation?.test_reports?.length" class="test-tabs reportsTableWidth" id="vue-tabs">
        <div class="test-panel">
          <div class="primary-content-view-new" v-loading="loading">
            <div
              class="listings listings__table listings__all-cases"
              id="all-cases-listings"
            >
              <el-table :data="getSendOutInformation?.test_reports" style="width: 100%">
                <el-table-column
                  prop="action"
                  label="REPORTS"
                  width="400"
                >
                  <template #default="scope">
                    <ul class="action-test-icons view-test">
                      <li
                        style="margin-right: 10px"
                        v-if="
                          scope.row.case_type == 'COVID' ||
                          scope.row.case_type == 'COVID_FLU'
                        "
                      >
                        <div
                          class="column-status"
                          v-if="scope.row.covid_status"
                        >
                          <span class="el-dropdown-link">
                            <el-tag
                              :type="
                                getCovidStatusType(scope.row.covid_status)
                              "
                              >{{ scope.row.covid_status }}</el-tag
                            >
                          </span>
                        </div>
                      </li>
                      <li
                        style="margin-right: 10px"
                        v-if="
                          scope.row.case_type ==
                            'RESPIRATORY_PATHOGEN_PANEL' ||
                          scope.row.case_type == 'URINALYSIS' ||
                          scope.row.case_type == 'UTI' ||
                          scope.row.case_type == 'TOXICOLOGY'
                        "
                      >
                        <div
                          class="column-status"
                          v-if="scope.row.result_status"
                        >
                          <span class="el-dropdown-link">
                            <el-tag
                              :type="
                                getCovidStatusType(scope.row.result_status)
                              "
                              >{{ scope.row.result_status }}</el-tag
                            >
                          </span>
                        </div>
                      </li>

                      <li
                        v-if="
                          !scope.row.is_supplemental_report ||
                          (scope.row.is_supplemental_report &&
                            scope.row.template_report_merged)
                        "
                      >
                        <el-button
                          class="action-download"
                          @click="onDownloadReport(scope.row, false, false)"
                          title="Download"
                        >
                          <span>
                            <img
                              class="testreports-active"
                              src="@/assets/images/icons/Download_1.svg"
                              alt="icon"
                              style="width: 22px"
                            />
                          </span>
                        </el-button>
                      </li>
                      <li
                      >
                        <el-button
                          class="action-view"
                          @click="viewReport(scope.row)"
                          title="View"
                        >
                          <img
                            class="testreports-active"
                            src="@/assets/images/icons/view_1.svg"
                            alt="icon"
                            style="width: 22px"
                          />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="time"
                  label="DATE & TIME"
                  width="350"
                >
                  <template #default="scope">
                    <span>
                      {{
                        momentWithTimezone(
                          scope.row.time,
                          "MM-DD-YYYY hh:mm A"
                        )
                      }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="TYPE" width="320">
                  <template #default="scope">
                    <span>{{ scope.row.type ? scope.row.type : 'Regular Report'}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      activeName: "",
      caseId: "",
      loading: false,
      testReports: [],
      caseTypes: [],
    };
  },
  mixins: [AppHelper, caseDataHelper, UserPermissionsHelper],
  computed: {
    ...mapGetters("sendOuts", ["getSendOutInformation"]),
    ...mapGetters("cases", [
      "getReportPreview"
    ]),
    getCovidStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else if (status == "INCONSISTENT") {
          return "warning";
        } else if (status == "CONSISTENT") {
          return "success";
        } else {
          return "";
        }
      };
    },
  },
  methods: {
    async viewReport(report) {
      let routerData = this.$router.resolve({
        name: "supplementaryReportView",
        params: {
          report_id: report._id,
          case_id: this.getSendOutInformation?.case_id,
        },
      });
      window.open(routerData.href, "_blank");
    },
    async onDownloadReport(report) {
      try {
        this.loading = true;
        this.$store.commit("errors/clear", null, { root: true });
        await this.$store.dispatch("cases/fetchReportPreview", {
          id: report._id,
          caseId: this.getSendOutInformation?.case_id
        });
        let url = this.getReportPreview?.download_url;
        if (url) {
          // Force download
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "report.pdf"); // you can set dynamic file name
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          successNotification("Report downloaded successfully");
        } else {
          errorNotification("Error while downloading report");
        }
      } catch (err) {
        errorNotification("Error while downloading report");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
.test-reports-not-available {
  text-align: center;
  padding: 1rem 0;
  color: #f24a65;
  font-weight: 500;
}
.case-creation__heading {
  overflow: hidden;
}
#view-test-information-sendouts {
  .test-reports {
    display: grid;
    grid-template-columns: 200px auto;
    column-gap: 15px;
    .el-switch .el-switch__core {
      width: 34px !important;
      height: 14.5px;
      border: none;
      background-color: #0a5da6;
      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2px;
        left: 2.1px;
      }
    }
    .el-switch__label.is-active {
      color: #0a5da6;
    }
    .el-switch.is-checked {
      .el-switch__core {
        background-color: #4bb543 !important;
      }
      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2px;
        left: 38px;
      }
    }

    .single-reports {
      margin-left: 20px;
    }
  }
  .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
  }
  .test-tabs {
    .el-tabs__nav-scroll {
      padding: 0 15px;
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
    .el-tabs__header {
      margin-bottom: 5px;
    }
    .test-panel {
      padding: 5px 10px 10px;
      .title-icon {
        padding: 0 6px;
        min-height: 20px;
        border: none;
        background: none;
        img {
          vertical-align: text-top;
        }
      }
      .icons {
        display: flex;
        justify-content: flex-end;
        padding: 2px 7px 12px 7px;
        .el-button {
          padding: 0;
          min-height: 21px;
          border: none;
          background: none;
        }
        .el-icon {
          .icon {
            width: 18px;
            height: 18px;
            color: #2979ff;
            padding-top: 3px;
          }
          &.cancel {
            margin-left: 8px;
          }
        }
      }
      .el-table {
        background: #eef2f5;
        padding: 0 10px;

        .el-table__cell {
          padding: 5px 0;
        }
      }
      .el-table__header {
        border-spacing: 0 2.5px;
        color: rgba(0, 0, 0, 0.8);
      }
      .el-table__body {
        border-spacing: 0 2.5px;
      }
      .el-table thead {
        color: rgba(0, 0, 0, 0.8);
        font-weight: 500;
      }
      .hours {
        margin-left: 10px;
      }
      .el-icon-edit {
        min-height: 25px;
        padding: 0 5px;
        background-color: #f24a55;
        color: #ffff;
        border: none;
      }
      .edit-icon {
        cursor: pointer;
        position: relative;

        top: 3px;
      }
    }
    .el-tabs__active-bar {
      background-color: #0a5da6;
      border-radius: 25px;
      height: 2px;
    }
    .el-tabs__item.is-active {
      color: #0a5da6;
      font-weight: 500;
    }
    .el-tabs__item:hover {
      color: #828282;
    }
    .el-tabs__item {
      color: #828282;
    }
    .el-table {
      .el-table__cell {
        .cell {
          font-weight: 500 !important;
        }
      }
    }
    .types {
      padding-top: 1rem;

      .el-form-item {
        display: block !important;
        margin: 0;
      }
      .case-type {
        &.view-reports-dialog {
          .el-button {
            border: 1px dashed #bababc;
            min-height: 30px;
            padding: 0 34px;
            background-color: #f2f6f9;
            width: 100%;
            font-size: 11px;
            span {
              display: flex;
              align-items: center;
              justify-content: center;
              color: #333333;
              p {
                color: #333333;
                font-weight: 400;
              }
              img {
                margin-right: 6px;
              }
            }
          }
        }
        .el-input__inner {
          border: 1px solid #56ccf2cc;
          height: 30px;
        }
      }
      .btn {
        margin-top: 22px;
        .el-button {
          color: #fff;
          padding: 8px 24px;
          min-height: 30px;
          border-radius: 7px;
          background: linear-gradient(
            79.26deg,
            #f24a55 -13.43%,
            #0a5da6 137.71%
          );
          border: none;
        }
        .submit-report {
          color: #fff;
          padding: 8px 24px;
          min-height: 30px;
          border-radius: 7px;
          background: linear-gradient(
            79.26deg,
            #f24a55 -13.43%,
            #0a5da6 137.71%
          );
          border: none;
        }
      }
    }
    .view-test {
      display: flex;
      font: icon;
      align-items: center;

      .el-button {
        padding: 0;
        margin-right: 10px;
        min-height: 20px;
        border: none;
        background: none;
      }
      .resend-notify-button {
        color: #10182f;
        margin-right: 7px;
        padding: 4px 0;
        border-radius: 5px;
        &:hover {
          color: #0a5da6;
        }
      }
    }
  }
  .physician-btn {
    .el-switch .el-switch__core {
      width: 34px !important;
      height: 15px;
      border: none;
      background-color: #0a5da6;
      .el-switch__action {
        height: 9px;
        width: 9px;
        top: 3px;
        left: 2px;
      }
    }
    .el-switch__label.is-active {
      color: #0a5da6;
    }
    .el-switch.is-checked {
      .el-switch__core {
        width: 34px !important;
        height: 15px;
        border: none;
        background-color: #4bb543 !important;
      }
      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2.2px;
        left: 38.5px;
      }
    }
  }
  .tox-finalize-btn {
    margin-left: 20px;
    .el-button {
      border: 0.6px solid #273480;
      background: #f2f2f2;
      color: #273480;
      min-height: auto;
      padding: 5px 15px;
      text-align: center;
      font-size: 13px;
      letter-spacing: 0;
      &:hover,
      &:focus {
        color: #273480;
        border: 0.6px solid #273480;
        background: #f2f2f2;
      }
    }
  }
}
.no-test-block {
  color: #f24a55;
  display: flex;
  align-items: center;
  text-emphasis: center;
  height: 60px;
  justify-content: center;
}
.reportsTableWidth {
  .el-table {
    table {
      width: 100% !important;
    }
  }
  .el-table__body-wrapper {
    width: 100% !important;
  }
}
</style>
